// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LOEb","newExpiryDate":"styles_newExpiryDate__34Q_d","footer":"styles_footer__SOG_q"};